// internal
import { axios, def, array, storage, handleError, handleResponse } from './internal';
import { coolDownBegin, coolDownEnd } from '../request-control/cooldown';

function Comment(postId, content, parentCommentId, setData, buildCommentTree, onSuccess) {
    const key = `comment:${postId}`;
    if (!coolDownBegin(key)) return; // the previous request is still running or just finished (double click)
    setData?.((prev) => ({ ...prev, loading: true }));
    axios
        .post(`/api/posts/${encodeURIComponent(postId)}/comments`, {
            content,
            parentCommentId,
        })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    // The server only returns the id and the time; the author is this user (session) and the count is
                    // the caller's count plus one.
                    const { commentId, date } = res.data.data;
                    const {
                        _id: userId,
                        username,
                        image,
                        thumbnail,
                        imageStatus,
                        status,
                        type,
                        badges,
                        createdAt,
                    } = storage.transience.getValue('user') ?? {};
                    const comment = {
                        _id: commentId,
                        postId,
                        userId,
                        content,
                        parentCommentId: parentCommentId ?? null,
                        date,
                        user: { _id: userId, username, image, thumbnail, imageStatus, status, type, badges, createdAt },
                        likeCount: 0,
                        liked: false,
                        // Being text-checked: the author sees loading dots in place of the text until the next load.
                        processing: true,
                    };
                    setData((prev) => {
                        const data = array.insertInArray(prev.data, comment);
                        const treeData = buildCommentTree(data);
                        return { ...prev, data: data, treeData: treeData };
                    });
                    onSuccess?.();
                    break;
                case def.ErrorCode.RESTRICTION: {
                    const penalty = res.data.data?.restriction;
                    const until = penalty?.expiresAt
                        ? ` Restriction ends: ${new Date(penalty.expiresAt).toLocaleString()}.`
                        : '';
                    storage.transience.setState(
                        'internal.warning',
                        `Your comments have been temporarily restricted due to repeated policy violations.${until}`,
                    );
                    break;
                }
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        })
        .finally(() => {
            coolDownEnd(key);
            setData?.((prev) => ({ ...prev, loading: false }));
        });
}

export { Comment };
